module.exports = __webpack_public_path__ + "img/hall3.6389fa3a.jpg";